import React, { useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import {
  useImportGeoJsonMutation, useImportGpxMutation,
} from '../../api/JsdhNotifikaceService/service/HydrantBodMutations';

interface Props { open: boolean; onClose: () => void; }

const HydrantImportDialog: React.FC<Props> = ({ open, onClose }) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const importGeoJson = useImportGeoJsonMutation();
  const importGpx = useImportGpxMutation();

  const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = '';
    const text = await file.text();
    try {
      if (file.name.toLowerCase().endsWith('.gpx')) await importGpx.mutateAsync(text);
      else await importGeoJson.mutateAsync(text);
      onClose();
    } catch { /* toast shown by onError; keep dialog open for retry */ }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Import hydrantů (GeoJSON / GPX)</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Vyberte soubor .geojson nebo .gpx. Každý bod (feature/waypoint) se založí jako samostatný hydrant.
          </Typography>
          <input ref={fileRef} type="file" accept=".geojson,.json,.gpx" hidden onChange={handleFile} />
          <Button variant="contained" onClick={() => fileRef.current?.click()}
            disabled={importGeoJson.isPending || importGpx.isPending}>
            Vybrat soubor
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Zavřít</Button>
      </DialogActions>
    </Dialog>
  );
};

export default HydrantImportDialog;
